import { TableNoVerticalLines } from 'components/base/layout-components';
import {
  StyledMultipleTokensView,
  StyledPatModalSubHeader,
  StyledTokensList
} from './MultipleTokensView.style';
import useTokensTable from './TokensTable/useTokensTable';
import Table from 'components/base/Table';
import EmptyState from './EmptyState';

const MultipleTokensView = ({ multiTokens }) => {
  const { rows, cols } = useTokensTable({ multiTokens });

  return (
    <StyledMultipleTokensView>
      <StyledPatModalSubHeader>Tokens list:</StyledPatModalSubHeader>
      <StyledTokensList>
        <TableNoVerticalLines>
          <Table
            isLoading={multiTokens.isLoading}
            columns={cols}
            data={rows}
            sortBy={multiTokens.sortBy.key}
            sortOrder={multiTokens.sortBy.dir}
            onSort={multiTokens.sortBy.onChange}
            allowEmptyData
            EmptyDataPlaceHolder={EmptyState}
          />
        </TableNoVerticalLines>
      </StyledTokensList>
    </StyledMultipleTokensView>
  );
};

export default MultipleTokensView;
